export const updateFilters = ({ commit, state }, payload) => {
    commit('updateFilters', payload);
}

export const updatePhoneNumber = ({ commit, state }, payload) => {
    commit('updatePhoneNumber', payload);
}

export const updateQuotation = ({ commit, state }, payload) => {
    commit('updateQuotation', payload);
}

/*
 * Authentication
 */

export const updateToken = ({ commit, state }, payload) => {
    commit('updateToken', payload);
}

export const updateOTPExpiration = ({ commit, state }, payload) => {
    commit('updateOTPExpiration', payload);
}

export const updateUserId = ({ commit, state }, payload) => {
    commit('updateUserId', payload);
}

export const logout = ({ commit, state }) => {
    return new Promise((resolve, reject) => {
        commit('logout');
        localStorage.removeItem('token');
        delete window.axios.defaults.headers.common['Authorization'];
        resolve();
    });
}
